/**
 * Validates a Canada postal code.
 * @param {string} postalCode - The postal code to validate.
 * @returns {boolean} - Returns true if the postal code is valid, false otherwise.
 */
export const validateCanadaPostalCode = (postalCode: string): boolean => {
	if (!postalCode) {
		return false;
	}

	// Regular expression for Canadian postal code
	const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

	// Test the postal code against the regex
	return postalCodeRegex.test(postalCode.trim());
};
